// Travel Partners SSO Integration Script
document.addEventListener("DOMContentLoaded", function () {
  injectSpinnerStyles();
  
  // Small delay to ensure DOM is fully loaded
  setTimeout(() => {
    const buttons = document.querySelectorAll('.travel-button');
    buttons.forEach(button => {
      button.addEventListener("click", handleTravelClick);
    });
  }, 500);
});

// =============================
// Get sessionId from window variable
// =============================
function getSessionIdFromMeta() {
  if (window.sessionId) {
    const sessionId = window.sessionId;
    if (sessionId && sessionId.trim() !== '') {
      return sessionId;
    }
  }
  return null;
}

// =============================
// Get membership number from window variable
// =============================
function getMembershipNumberFromMeta() {
  if (window.customerMembershipNumber) {
    const membershipNumber = window.customerMembershipNumber;
    if (membershipNumber && membershipNumber.trim() !== '') {
      return membershipNumber;
    }
  }
  return null;
}

// =============================
// Spinner helpers
// =============================
function injectSpinnerStyles() {
  if (document.getElementById('sso-spinner-styles')) return;
  const styles = `
    <style id="sso-spinner-styles">
      .sso-loading-overlay {
        position: fixed; top: 0; left: 0; width: 100%; height: 100%;
        background: rgba(0, 0, 0, 0.5); display: flex; justify-content: center; align-items: center;
        z-index: 9999; opacity: 0; visibility: hidden;
        transition: opacity 0.3s ease, visibility 0.3s ease;
      }
      .sso-loading-overlay.show { opacity: 1; visibility: visible; }
      .sso-spinner-container { background: white; padding: 30px; border-radius: 10px;
        text-align: center; box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15); max-width: 300px; }
      .sso-spinner { width: 40px; height: 40px; border: 4px solid #f3f3f3; border-top: 4px solid #007bff;
        border-radius: 50%; animation: sso-spin 1s linear infinite; margin: 0 auto 15px; }
      @keyframes sso-spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
      .sso-loading-text { color: #333; font-size: 16px; margin: 0; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; }
    </style>
  `;
  document.head.insertAdjacentHTML('beforeend', styles);
}

function showLoadingSpinner(message = "Redirecting to Travel Partners...") {
  let overlay = document.getElementById('sso-loading-overlay');
  if (!overlay) {
    const spinnerHTML = `
      <div id="sso-loading-overlay" class="sso-loading-overlay">
        <div class="sso-spinner-container">
          <div class="sso-spinner"></div>
          <p class="sso-loading-text">${message}</p>
        </div>
      </div>
    `;
    document.body.insertAdjacentHTML('beforeend', spinnerHTML);
    overlay = document.getElementById('sso-loading-overlay');
    setTimeout(() => overlay.classList.add('show'), 10);
  } else {
    const textEl = overlay.querySelector('.sso-loading-text');
    if (textEl) textEl.textContent = message;
    overlay.classList.add('show');
  }
}

function hideLoadingSpinner() {
  const overlay = document.getElementById('sso-loading-overlay');
  if (overlay) {
    overlay.classList.remove('show');
    setTimeout(() => overlay.remove(), 300);
  }
}

// =============================
// WebView detection
// =============================
function isWebView() {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  
  const isIOSWebView = /iP(ad|hone|od)/.test(ua) && !/(Safari|CriOS|FxiOS|EdgiOS)/i.test(ua);
  const isAndroidWebView = /Android/.test(ua) && (/wv|Version\/\d+\.\d+/.test(ua) && !/Chrome\/[.0-9]*/.test(ua) || /; wv\)/.test(ua));
  
  const hasWebViewIndicators = 
    (window.ReactNativeWebView !== undefined) ||
    (window.flutter_inappwebview !== undefined) ||
    (window.webkit?.messageHandlers !== undefined) ||
    (typeof AndroidInterface !== 'undefined');
  
  return isIOSWebView || isAndroidWebView || hasWebViewIndicators;
}

// =============================
// Click handler
// =============================
function handleTravelClick(event) {
  event.preventDefault();

  const sessionId = getSessionIdFromMeta();
  const clientNumber = getMembershipNumberFromMeta();

  if (!sessionId) {
    alert("⚠️ Session not ready. Please refresh the page and try again.");
    return;
  }

  if (!clientNumber) {
    alert("⚠️ Membership information not found. Please refresh the page and try again.");
    return;
  }

  showLoadingSpinner("Logging you in...");

  getAuthToken(sessionId)
    .then(authToken => ssoLogin(clientNumber, authToken))
    .catch(err => {
      hideLoadingSpinner();
      alert("⚠️ Could not log in, please try again.");
    });
}

// =============================
// API helpers
// =============================
function getAuthToken(sessionId) {
  if (!sessionId) {
    return Promise.reject("Session ID not found.");
  }
  
   const authUrl = "https://multiply-mall-backend-pre.multiply.co.za/api/Multipass/AccessToken?sessionId=" + encodeURIComponent(sessionId);
  // const authUrl = "https://multiply-mall-backend.multiply.co.za/api/Multipass/AccessToken?sessionId=" + encodeURIComponent(sessionId);
  
  return fetch(authUrl)
    .then(res => {
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      return res.text();
              console.error("SSO ERROR:", res.text());
    })
    .then(text => {
      if (!text) throw new Error("Empty response");
      return text;

       console.error("SSO ERROR:", res.text());
    });
}

function ssoLogin(clientNumber, authToken) {
  // const ssoUrl = "https://webprd.multiply.co.za/multiply-api-gateway/partner/v1/multiply/travel/singleSignOn";
  const ssoUrl = "https://webpre.multiply.co.za/multiply-api-gateway/partner/v1/multiply/travel/singleSignOn";
  return fetch(ssoUrl, {
    method: "POST",
    headers: { 
      "Content-Type": "application/json", 
      "Authorization": `Bearer ${authToken}` 
    },
    body: JSON.stringify({ clientNumber })
  })
    .then(res => { 
      if (!res.ok) throw new Error(`HTTP ${res.status}`); 
      return res.json(); 
    })
    .then(data => {
      hideLoadingSpinner();
      
      if (!data.RedirectURL) {
        const errorMsg = data.ErrorMsg || "Login failed";
        throw new Error(errorMsg);
      }

      if (isWebView()) {
        window.location.href = data.RedirectURL;
      } else {
        window.open(data.RedirectURL, "_blank");
      }
    })
    .catch(err => {
      hideLoadingSpinner();
      alert("⚠️ An error occurred. Please try again.");
      throw err;
        console.error("SSO ERROR:", err);
    });
}

// =============================
// Cleanup on back navigation
// =============================
function cleanupOnReturn() {
  const overlay = document.getElementById('sso-loading-overlay');
  if (overlay) {
    overlay.remove();
  }

  const nativeSpinnerSelectors = [
    '.loading-spinner',
    '.native-spinner',
    '.webview-loading',
    '[class*="spinner"]',
    '[class*="loading"]',
    '[id*="spinner"]',
    '[id*="loading"]'
  ];

  nativeSpinnerSelectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(el => {
      const style = window.getComputedStyle(el);
      if (style.position === 'fixed' || style.position === 'absolute') {
        if (el.offsetWidth < 200 && el.offsetHeight < 200) {
          el.remove();
        }
      }
    });
  });
}

window.addEventListener('pageshow', cleanupOnReturn);

document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    cleanupOnReturn();
  }
});

